import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { MTopBar } from "@/components/mobile/MTopBar";
import { MPage, SearchBox, Fab, EmptyArt, Loading } from "@/components/mobile/parts";
import { ComandaCard } from "@/components/mobile/ComandaCard";
import { MineToggle, useMine } from "@/components/mobile/MineToggle";
import { useOpenComandas } from "@/hooks/useMobileData";
import { useAuth } from "@/context/AuthContext";
import { filterComandas, isDirect } from "@/lib/mobile";

function DirectStart() {
  const nav = useNavigate();
  return (
    <div className="flex min-h-[65vh] flex-col items-center justify-center gap-5 text-center fade-up" data-testid="m-pdv-direct">
      <button onClick={() => nav("/m/venda-direta")} aria-label="Nova venda" data-testid="m-pdv-new-sale-btn"
        className="grid h-40 w-40 place-items-center rounded-full bg-[#1565c0] text-white shadow-2xl shadow-blue-900/30 transition-transform hover:bg-[#0d47a1] active:scale-95">
        <Plus className="h-20 w-20" strokeWidth={2.5} />
      </button>
      <div>
        <p className="font-display text-2xl font-bold">Nova venda</p>
        <p className="text-sm text-slate-500">Toque para escolher os produtos da venda direta</p>
      </div>
    </div>
  );
}

function ComandasPdv() {
  const { list } = useOpenComandas();
  const [q, setQ] = useState("");
  const nav = useNavigate();
  const { enabled, mine, setMine, apply } = useMine();
  const shown = filterComandas(apply(list || []), q);
  return (
    <>
      <MPage>
        <SearchBox value={q} onChange={setQ} placeholder="Buscar comanda por número ou nome" testId="m-pdv-search" />
        {enabled && <MineToggle mine={mine} setMine={setMine} count={shown.length} />}
        {!list ? <Loading /> : !list.length ? (
          <EmptyArt plus title="Nenhuma comanda aberta" text="Toque no botão + no canto da tela para abrir uma nova comanda e começar a lançar os pedidos." testId="m-pdv-empty" />
        ) : (
          <div className="space-y-2.5" data-testid="m-pdv-list">
            <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">{shown.length} comanda(s) aberta(s){mine ? " · minhas" : ""}</p>
            {shown.map((c) => <ComandaCard key={c.id} c={c} showWaiter={enabled} onClick={() => nav(`/m/comanda/${c.id}`)} />)}
            {!shown.length && <p className="py-8 text-center text-sm text-slate-500">{mine ? "Você não tem comandas abertas." : "Nenhuma comanda encontrada."}</p>}
          </div>
        )}
      </MPage>
      <Fab onClick={() => nav("/m/nova")} label="Nova comanda" testId="m-new-comanda-fab" />
    </>
  );
}

export default function MPdv() {
  const { session } = useAuth();
  return (
    <>
      <MTopBar title="PDV" />
      {isDirect(session.user, session.tenant) ? <MPage><DirectStart /></MPage> : <ComandasPdv />}
    </>
  );
}
